import { ListItemIcon, ListItemText, MenuItem, MenuList } from '@mui/material'
import BuildIcon from '@mui/icons-material/Build'
import Router, { useRouter } from 'next/router'
import React, { FC, useCallback, useMemo } from 'react'
import { TtoggleDrawerOnMobile } from '../../containers/Sidebar/Sidebar'
import useOrgChecker from '../../hooks/useOrgChecker'
import { useStyles } from '../../containers/Sidebar/Sidebar.styles'

interface Props {
  permissions?: []
  toggleDrawerOnMobile: TtoggleDrawerOnMobile
  openDrawer: boolean
  hoverDrawer: boolean
}

const SDKDebuggerSubMenu: FC<Props> = ({ toggleDrawerOnMobile, openDrawer, hoverDrawer }) => {
  const { pathname } = useRouter()
  const { isNova } = useOrgChecker()
  const selected = useMemo(() => pathname.includes('/sdk-debugger'), [pathname])
  const onClick = useCallback(() => Router.push('/sdk-debugger'), [])
  const classes = useStyles({ openDrawer, hoverDrawer })
  return isNova ? (
    <MenuList
      aria-labelledby="nested-list-subheader"
      onClick={toggleDrawerOnMobile}
      className={classes.root}
    >
      <MenuItem
        selected={selected}
        onClick={onClick}
        className={classes.menuItem}
      >
        <ListItemIcon>
          <BuildIcon />
        </ListItemIcon>
        <ListItemText primary="SDK Debugger" hidden={!openDrawer && !hoverDrawer} />
      </MenuItem>
    </MenuList>
  ) : null
}

export default SDKDebuggerSubMenu
